<template>
    <label
        :for="settings.name"
        class="field__label display--inline-b"
        :class="[ settings.class, { 'pointer': settings.allowFilling }]">
            <span
                v-if="settings.showIcon"
                class="field__checkbox__icon field__checkbox__icon--field display--inline-b position--absolute background--grey--light"
                aria-hidden="true"
                :aria-label="$t('accessibility.arrow')"></span>
            <template v-if="!settings.isNecessaryPre">
                {{ settings.text }}
            </template>
            <pre v-else class="field__label__pre">{{ settings.text }}</pre>

            <span v-if="settings.isRequired" class="label__required"> *</span>
    </label>
</template>

<script>
export default {
    props: {
        settings: Object
    }
};
</script>